import type { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import React from 'react';

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  title: string;
}

// function IconWrapper({ children }: PropsWithChildren<unknown>) {
//   return <span className="icon inline-flex items-center text-primary">{children}</span>;
// }

export default function NavigationAnchor({
  children,
  className,
  ...aProps
}: PropsWithChildren<IProps>) {
  return (
    <a {...aProps} className={`inline-flex flex-auto gap-2 font-medium p-4 ${className}`}>
      {children}
    </a>
  );
}
